import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import useOrganisationSettings from 'components/hooks/useOrganisationSettings';
import { TruncatedTextBodyMedium } from 'screens/Levelup/LevelUpCF/constants';
import { KRNameAndProgressCell } from 'screens/home/summary/components/Cards/Goals/components/KRNameAndProgressCell';
import { ObjectiveNameAndProgressCell } from 'screens/home/summary/components/Cards/Goals/components/ObjectiveNameAndProgressCell';

import { KeyResultPrivate2 } from 'assets/assetsV1/iconComponents';
import { KeyResult } from 'assets/assetsV1/iconComponents/KeyResult';
import { Objective } from 'assets/assetsV1/iconComponents/Objective';

import { StringModifier, modifyString } from 'constants/copyHelpers';

export const ObjectiveKRCellOneOnOne = ({ data }) => {
  const { type, visibilityType, unMasked } = data ?? {};
  const isObjective = type === 'OBJECTIVE';

  const isPrivateKR = visibilityType === 'PRIVATE';

  const { moduleName } = useOrganisationSettings();

  if (!unMasked) {
    return (
      <Box w="100%">
        <Flex alignItems="flex-start">
          <KeyResultPrivate2 color="#4657AE" boxSize="24px" />
          <Flex ml="6px" flexDir="column" w="100%">
            <TruncatedTextBodyMedium
              style={{ fontStyle: 'italic' }}
              className="highlight-able-text"
              mb={isObjective ? '1px' : 0}
            >
              You do not have access to this private {modifyString(moduleName, StringModifier.SENTENCE_CASE)}
            </TruncatedTextBodyMedium>
          </Flex>
        </Flex>
      </Box>
    );
  }

  return (
    <Box pt={2} pb={3} px={1}>
      <Flex alignItems="flex-start" width="100%">
        {isObjective ? (
          <>
            <Objective color="#7651BC" boxSize="24px" />
            <ObjectiveNameAndProgressCell data={data} w="200px" />
          </>
        ) : (
          <>
            {isPrivateKR ? (
              <KeyResultPrivate2 color="#4657AE" boxSize="24px" />
            ) : (
              <KeyResult color="#4657AE" boxSize="24px" />
            )}
            <KRNameAndProgressCell data={data} w="200px" />
          </>
        )}
      </Flex>
    </Box>
  );
};
